// Is a given value a DOM element?
export default function isElement(obj) {
    return !!(obj && obj.nodeType === 1);
}
